// extracted by mini-css-extract-plugin
export var menuIcon = "_op-0";
export var menuIconInline = "_op-1";